// date
import {parse, getUnixTime, isDate, endOfDay} from 'date-fns';

const convertDateToUnix = ({date, dateFormat = 'yyyy-MM-dd'}) =>
  getUnixTime(
    endOfDay(isDate(date) ? date : parse(date, dateFormat, new Date()))
  ) * 1000;

export default convertDateToUnix;
